import React from 'react';
import {
  FormControl,
  TextField as MuiTextField,
  TextFieldProps as MuiTextFieldProps
} from '@mui/material';
import clsx from 'clsx';

import { FormContext, FormRefsContext } from '../../contexts';
import { FormMode } from '../../enums';
import { TooltipContainer } from '../tooltip-container';
import { TextFieldProps } from '../../interfaces/field-props/text-field-props.interfaces';

export function TextField({
  muiProps,
  ...props
}: TextFieldProps & { muiProps?: Partial<MuiTextFieldProps> }): JSX.Element {
  const { formMode } = React.useContext(FormContext);
  const { fieldsRefs } = React.useContext(FormRefsContext);
  return (
    <TooltipContainer tooltip={props.tooltip}>
      <FormControl
        id={props.id}
        className={clsx(
          {
            'form-field': true,
            'required-submit': props.requiredToSubmit
          },
          props.className
        )}
        fullWidth
      >
        <MuiTextField
          label={props.label}
          disabled={props.disabled || formMode === FormMode.ReadOnly}
          required={props.required}
          defaultValue={props.defaultValue}
          variant='outlined'
          InputProps={{
            inputProps: {
              minLength: props.minLength,
              maxLength: props.maxLength
            }
          }}
          onInput={(event: React.FormEvent<HTMLDivElement>): void => {
            const inputElement = event.target as HTMLInputElement;
            let newValue = inputElement.value;
            if (props.notAllowedWhiteSpaces === 'both') {
              newValue = newValue.replace(/\s/g, '');
            } else if (props.notAllowedWhiteSpaces === 'end') {
              newValue = newValue.trimEnd();
            } else if (props.notAllowedWhiteSpaces === 'start') {
              newValue = newValue.trimStart();
            }
            if (props.replaceRegex) {
              const regex = new RegExp(props.replaceRegex, 'i');
              newValue = newValue.replace(regex, '');
            }
            inputElement.value = newValue.slice(0, props.maxLength);
          }}
          {...muiProps}
          ref={(el: HTMLInputElement) => {
            if (fieldsRefs && muiProps?.name) {
              fieldsRefs.current[muiProps.name] = el;
            }
          }}
        />
      </FormControl>
    </TooltipContainer>
  );
}
